
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class ValidationResultModel extends Model<ValidationResultModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'valid', type: 'boolean' },
		{ name: 'validationErrors', type: 'Record<string, Record<string, string>>', isArray: true, isDictionary: true }
	];
	[key: string]: any;
	
	public valid: boolean;
	public validationErrors: Record<string, Record<string, string>>;
    
	constructor(){
		super();
		this.valid = false;
		this.validationErrors = {};
		
	}
	getProperties(){
		return ValidationResultModel.classProperties;
	}
}

